import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVeiligheid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_5140_14768)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.473511 -0.027832H21.5266V16.6178L11.0001 22.158L0.473511 16.6178V-0.027832ZM2.47351 1.97217V15.4103L11.0001 19.8979L19.5266 15.4103V1.97217H2.47351ZM11.7535 5.6838C10.7489 5.1038 9.49307 5.82885 9.49307 6.98889V8.49588H12.5071V6.98889C12.5071 6.45048 12.2198 5.95296 11.7535 5.6838ZM14.5071 8.49588V6.98889C14.5071 5.73595 13.8386 4.57815 12.7535 3.95172C10.4155 2.60195 7.49307 4.28922 7.49307 6.98889V8.49588H5.98891V15.5098H16.0112V8.49588H14.5071ZM14.0112 10.4959H7.98891V13.5098H14.0112V10.4959Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5140_14768">
        <rect
          width={22}
          height={22}
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVeiligheid);

export default ForwardRef;
